import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';

import { SingleDatePicker } from '../../../../components';

import { LOCALES_OBJ } from 'constants/base';

import useStyles from './styles';

const OverviewCalendarHeader = ({
  startDate,
  endDate,
  changeWeekCallback,
  tabIndex,
  selectedDate,
  setSelectedDate
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  const isPreviousWeekButton = () => {
    return !moment().isBetween(startDate, endDate, 'day', '[]');
  };

  const handleDatePickerChanges = value => {
    setSelectedDate(value);
    changeWeekCallback({
      startDate: moment(value).startOf('isoWeek'),
      endDate: moment(value).endOf('isoWeek')
    });
  };

  const nextWeek = () => {
    const newStartDate = moment(startDate).add(7, 'day');
    changeWeekCallback({
      startDate: newStartDate,
      endDate: moment(endDate).add(7, 'day')
    });
  };

  const previousWeek = () => {
    const newStartDate = moment(startDate).subtract(7, 'day');
    changeWeekCallback({
      startDate: newStartDate,
      endDate: moment(endDate).subtract(7, 'day')
    });
  };

  const setCurrentWeek = () => {
    changeWeekCallback({
      startDate: moment().startOf('isoWeek'),
      endDate: moment().endOf('isoWeek')
    });
  };

  return (
    <div className={classes.header}>
      <div className={classes.backAction}>
        <Button
          startIcon={<KeyboardBackspaceIcon className={classes.backIcon} />}
          onClick={() => {
            history.push({
              pathname: '/',
              state: {
                tabNumber: tabIndex
              }
            });
          }}
        >
          <Typography variant="body1" className={classes.backButtonTitle}>
            {t('Back')}
          </Typography>
        </Button>
        <Typography variant="h1" className={classes.headerTitle}>
          {t('Calendar')}
        </Typography>
      </div>
      <div className={classes.rangeWrapper}>
        <Button
          variant="outlined"
          className={classes.button}
          onClick={setCurrentWeek}
        >
          <Typography variant="body1" className={classes.todayTitle}>
            {t('Today')}
          </Typography>
        </Button>
        <div className={classes.range}>
          <ArrowBackIosOutlinedIcon
            className={classNames(classes.rangeIcon, {
              [classes.disabledRangeIcon]: !isPreviousWeekButton()
            })}
            onClick={() => isPreviousWeekButton() && previousWeek()}
          />
          <Typography variant="body1" className={classes.rangeDates}>
            {moment(startDate)
              .locale(LOCALES_OBJ[selectedLanguage])
              .format('MMMM D, YYYY')}{' '}
            –{' '}
            {moment(endDate)
              .locale(LOCALES_OBJ[selectedLanguage])
              .format('MMMM D, YYYY')}
          </Typography>
          <ArrowForwardIosOutlinedIcon
            className={classes.rangeIcon}
            onClick={nextWeek}
          />
           <div className={classes.datePickerWrapper}>
              <SingleDatePicker
                id="rangeStartDate"
                name="range.startDate"
                label="Start date"
                isInput={true}
                numberOfMonths={2}
                daySize={39}
                isWidgetSearch={true}
                placeholder="Select date"
                className={classes.datePickerButton}
                anchorDirection="right"
                input={{
                  value: selectedDate,
                  onChange: handleDatePickerChanges
                }}
                meta={{
                  touched: null,
                  error: null,
                  submitFailed: null
                }}
                isIcon={true}
              />
             </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewCalendarHeader;
